import React, { useState } from "react";
import classes from './style.module.scss';
import useStyles from 'isomorphic-style-loader/useStyles';
import Mask from '../../../../../../desktop/components/mask';
import DisplayTransition from "../../../../../../desktop/components/transitions/display-transition";
import { BlackMask } from "../../../../../../components/mask";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { FormattedMessage } from "react-intl";

export const Content = props => {
    useStyles(classes)
    return <div className={classes.Content}>
        <Iconfont onClick={props.onClose} className={classes.Close}>&#xe7c9;</Iconfont>
        <div className={classes.ContentText}>
            <FormattedMessage id={"cvv_tip"} defaultMessage={"For a successful payment, please enter your Credit Card Verification Number (CVV). You can find the CVV number on the back of your credit card."}/>
        </div>
        <div className={classes.ContenImg}>
            <img src={`${IMAGE_GEEKO_LTD}/chicme/20231010064435331453.png`} alt="" />
        </div>
    </div>
}


const ContentEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <DisplayTransition in={props.show} style={{zIndex: props.zIndex}} className={classes.AskContainer}>
            <div>
                <Content {...props} />
            </div>
        </DisplayTransition>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}

const AskMask = props => {
    useStyles(classes)
    const [show, setShow] = useState(false)

    const clickHandle = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setShow(true)
    }

    return <React.Fragment>
        <span className={classes.Ask} onClick={clickHandle}>?</span>

        <ContentEditor {...props} show={show} onClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShow(false)
        }} />
    </React.Fragment>
}

export default AskMask